// Where to get the operator app.
//
// Environment-specific, and NOT interchangeable: the staging app is
// distributed through Firebase App Distribution, not Play. Sending a staging
// operator to Play installs the *production* app, which cannot see a staging
// workspace, so the workspace code they were given would never work.
// REACT_APP_APP_INSTALL_URL is set for staging builds; production falls back
// to the Play Store listing.
//
// This is the only app to offer anyone. The web dashboard is deliberately not
// installable (see the note on manifest.json in public/index.html).
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.shootstoreshare.shoot_store_share2025';

export const APP_INSTALL_URL = process.env.REACT_APP_APP_INSTALL_URL || PLAY_STORE_URL;

// A build handed out through Firebase App Distribution rather than Play. The
// getting-started checklist explains the tester request in that case instead
// of saying "Play Store", which a staging tester has no listing to follow.
export const APP_INSTALL_IS_TEST_BUILD = APP_INSTALL_URL !== PLAY_STORE_URL;
